<template>
  <div class="contain">
    <!-- 切换就诊人-结束就诊 -->
    <el-row class="containRow">
      <el-col :span="12">
        <span>
          当前有
          <span style="color: red">{{this.arrlength}}</span>人等候
        </span>

        <span class="color" @click="inquiryLi">
          <i class="fa fa-retweet"></i>
          切换看诊人
        </span>
      </el-col>
      <el-col :span="4">&nbsp;</el-col>
      <el-col :span="5">
        紧急程度：
        <template>
          <el-select v-model="situation" placeholder="请选择" @change="medicine">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-col>

      <el-col :span="3">
        <el-button style="background-color: #3C6EA9;color:#fff;border-radius: 10px;" class="finishDoctor" @click="finishDoctor">结束看诊</el-button>
      </el-col>
    </el-row>

    <div class="in-content">
      <el-row class="containRow" :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple Info">
            <div class="in-con">
              <img :src="info.img" class="doctorImg">
              <div class="in-file">
                <span>{{ info.name }}</span>
              </div>
              <div class="in-table">
                <div class="in-tabOne">
                  <h2>
                    性别:
                    <span>{{ info.sex }}</span>
                  </h2>
                </div>
                <div class="in-tabTwo">
                  <h2>
                    周岁:
                    <span>{{ info.age }}</span>
                  </h2>
                </div>
              </div>
              <div class="in-tel">
                <h2>
                  电话:
                  <span>{{ info.tel }}</span>
                </h2>
              </div>
            </div>

            <!--弹出窗（历史病例）-->
            <el-popover placement="top-start" width="800" trigger="click">
              <!-- 头部信息 -->
              <div>
                <p style="line-height: 50px;">历史病例：</p>
              </div>

              <!-- 手风琴 -->
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item
                  v-for="(items,index) in collapseData"
                  :title="items.inquiryDate+' '+items.diagnosisType+' '+items.patientName"
                  :name="index+1"
                  :key="index"
                >
                  <span v-if="items.medicalRecordResponse" class="subheading">
                    <div class="accordionTitle">病例</div>
                    <div>
                      <span>主诉:</span>
                      {{items.medicalRecordResponse.mainSuit}}
                    </div>
                    <div>
                      <span>现病史:</span>
                      {{items.medicalRecordResponse.hpi}}
                    </div>
                    <div>
                      <span>既往辅助检查:</span>
                      {{items.medicalRecordResponse.assistantExamination}}
                    </div>
                    <div>
                      <span>刻下:</span>
                      {{items.medicalRecordResponse.kexia}}
                    </div>
                    <div>
                      <span>舌苔:</span>
                      {{items.medicalRecordResponse.shetai}}
                    </div>
                    <div>
                      <span>脉象:</span>
                      {{items.medicalRecordResponse.pulseCondition}}
                    </div>
                    <div>
                      <span>西医:</span>
                      {{items.medicalRecordResponse.wDiagnosisResult}}
                    </div>
                    <div>
                      <span>病症名:</span>
                      {{items.medicalRecordResponse.mDiseasesZh}}
                    </div>
                    <div>
                      <span>英文病症名:</span>
                      {{items.medicalRecordResponse.mDiseasesEn}}
                    </div>
                    <div>
                      <span>症型:</span>
                      {{items.medicalRecordResponse.mDiagnosisResult}}
                    </div>
                  </span>
                  <span v-if="items.recipeResponse" class="subheading">
                    <div class="accordionTitle">中药汤方</div>
                    <span v-if="items.recipeResponse.recipeItemResponses">
                      <div
                        v-for="(citem,inx) in items.recipeResponse.recipeItemResponses"
                        :key="inx"
                        class="traditional"
                      >
                        <span>药品:</span>
                        {{citem.value}} - {{citem.number}}{{citem.unit}}
                      </div>
                    </span>
                    <div>
                      <span>副数:</span>
                      {{items.recipeResponse.quantity}}
                    </div>
                    <div>
                      <span>煎服法:</span>
                      {{items.recipeResponse.eatType}}
                    </div>
                    <div>
                      <span>忌口及日常护理:</span>
                      {{items.recipeResponse.note}}
                    </div>
                  </span>
                  <span v-if="items.otherCheckRecordResponse" class="subheading">
                    <div class="accordionTitle">辅助检查</div>
                    <div>
                      <span>项目名称:</span>
                      {{items.otherCheckRecordResponse.checkedName}}
                    </div>
                  </span>
                  <span v-if="items.recipeResponses" class="subheading">
                    <div class="accordionTitle">汤方信息</div>
                    <div v-for="(cell,index) in items.recipeResponses" :key="index">
                      <div>
                        <h3>{{cell.recipeName}}</h3>
                      </div>
                      <span v-for="(dall,index) in cell.recipeItemResponses" :key="index">
                        <span style="color: darkorange">
                          <span>{{dall.value}}</span>
                          <span>{{dall.number}}{{dall.unit}}</span>
                        </span>
                        <span style="padding:0 10px;">/</span>
                      </span>
                    </div>
                  </span>
                </el-collapse-item>
              </el-collapse>

              <!-- 显示弹出菜单 -->
              <el-button
                type="primary"
                style="margin-bottom: 30px;border-radius: 10px;background-color:#3C6EA9;"
                icon="el-icon-tickets"
                slot="reference"
              >历史病历</el-button>
            </el-popover>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">家族史</h2>
                <div class="circle">
                  <el-button style="background-color:#39C0E1;color:#fff;" @click="addOneRow('familyHistory')" icon="el-icon-plus" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('familyHistory')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.familyHistory">
                <el-input
                  :value="item"
                  type="textarea"
                  style="padding-top: 10px"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'familyHistory')"
                  v-model="all_sides.familyHistory[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">过往病史及过敏史</h2>
                <div class="circle">
                  <el-button style="background-color:#39C0E1;color:#fff;" @click="addOneRow('allergicHistory')" icon="el-icon-plus" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('allergicHistory')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.allergicHistory">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'allergicHistory')"
                  v-model="all_sides.allergicHistory[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree" v-if="info.sex == '女'">
              <div class="in-past">
                <h2 style="line-height:40px;">月经史，绝经期，孕产史</h2>
                <div class="circle">
                  <el-button style="background-color:#39C0E1;color:#fff;" @click="addOneRow('menstrual')" icon="el-icon-plus" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('menstrual')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.menstrual">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'menstrual')"
                  v-model="all_sides.menstrual[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">生活偏嗜</h2>
                <div class="circle">
                  <el-button style="background-color:#39C0E1;color:#fff;" @click="addOneRow('lifePartialAddicted')" icon="el-icon-plus" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('lifePartialAddicted')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.lifePartialAddicted">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'lifePartialAddicted')"
                  v-model="all_sides.lifePartialAddicted[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">病因病机</h2>
                <div class="circle">
                  <el-button style="background-color:#39C0E1;color:#fff;" @click="addOneRow('pathogenyAndPathology')" icon="el-icon-plus" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('pathogenyAndPathology')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.pathogenyAndPathology">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'pathogenyAndPathology')"
                  v-model="all_sides.pathogenyAndPathology[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree" v-if="false">
              <div class="in-past">
                <h2 style="line-height:40px;">侧边信息字段A</h2>
                <div class="circle">
                  <el-button style="background-color:#39C0E1;color:#fff;" @click="addOneRow('sideInformationA')" icon="el-icon-plus" circle></el-button>
                  <el-button type="danger" @click="deleteOneRow('sideInformationA')" icon="el-icon-delete" circle></el-button>
                </div>
              </div>
              <div class="in-disease" :key="index" v-for="(item,index) in all_sides.sideInformationA">
                <el-input
                  type="textarea"
                  style="padding-top: 10px"
                  :value="item"
                  autosize
                  placeholder="请输入内容"
                  @change="changeOneRow($event,index,'sideInformationA')"
                  v-model="all_sides.sideInformationA[index]"
                ></el-input>
              </div>
            </div>

            <div class="in-con in-conThree">
              <div class="in-past">
                <h2 style="line-height:40px;">病毒携带史</h2>
                <div class="circle">
                  <!--新增-->
                  <el-button
                    style="background-color:#39C0E1;color:#fff;"
                    @click="edit(dialogTableVisible = true)"
                    icon="el-icon-plus"
                    circle
                  ></el-button>
                </div>
              </div>

              <div style="margin-top: 10px">
                <el-table :data="gridData" style="width: 450px" border>
                  <el-table-column property="virus" label="病毒类型"></el-table-column>
                  <el-table-column property="year" label="持续时间"></el-table-column>
                  <el-table-column property="approach" label="感染途径"></el-table-column>
                  <el-table-column label="操作">
                    <template scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <br>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row,gridData)"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <el-dialog width="35%" :visible.sync="dialogFormVisible" append-to-body>
              <el-form>
                <el-form-item style="text-align:left;" label="病毒携带史:" :label-width="formLabelWidth">
                  <el-select v-model="virus" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in virusCarry"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="text-align:left;"
                  label="持续时间 - 年:"
                  :label-width="formLabelWidth"
                >
                  <template>
                    <el-input-number v-model="year" :precision="1" :step="0.1" :min="0.1"></el-input-number>
                  </template>
                </el-form-item>
                <el-form-item label="感染途径:" :label-width="formLabelWidth">
                  <el-autocomplete
                    style="width:100%;"
                    v-model="approach"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave(dialogFormVisible = false)">确 定</el-button>
              </div>
            </el-dialog>

            <el-dialog title="新增病毒携带史" :visible.sync="dialogTableVisible">
              <el-form>
                <el-form-item style="text-align:left;" label="病毒携带史:" :label-width="formLabelWidth">
                  <el-select v-model="virus" placeholder="请选择" filterable>
                    <el-option
                      v-for="(item,index) in virusCarry"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  style="text-align:left;"
                  label="持续时间 - 年:"
                  :label-width="formLabelWidth"
                >
                  <template>
                    <el-input-number v-model="year" :precision="1" :step="0.1" :min="0.1"></el-input-number>
                  </template>
                </el-form-item>
                <el-form-item label="感染途径:" :label-width="formLabelWidth">
                  <el-autocomplete
                    style="width:100%;"
                    v-model="approach"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="addbingdu(dialogTableVisible = false)">确 定</el-button>
              </div>
            </el-dialog>
            <el-button type="primary" @click="saveUserHistory">立即修改侧边病史</el-button>
          </div>
        </el-col>

        <el-col :span="17">
          <div class="grid-content bg-purple Info">
            <inquiryone :timeDate="timeDate" ref="c1"></inquiryone>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import InquiryOne from "./inquiryOne";

export default {
  data() {
    return {
      situation:1,     //紧急程度
      options: [{
        value: 0,
        label: '一般'
      }, {
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '紧急'
      }],
      arrlength: "",
      collapseData: [], //  手风琴
      state: 0, //  状态
      virusCarry: [
        //  病毒携带史
        {
          value: "乙肝",
          label: "乙肝"
        },
        {
          value: "丙肝",
          label: "丙肝"
        },
        {
          value: "HP",
          label: "HP"
        },
        {
          value: "HPV",
          label: "HPV"
        },
        {
          value: "梅毒",
          label: "梅毒"
        }
      ],
      gridData: [],
      virus: "",
      restaurants: [
        { value: "纹眉", address: "纹眉" },
        { value: "纹唇", address: "纹唇" },
        { value: "耳洞", address: "耳洞" },
        { value: "洗牙", address: "洗牙" },
        { value: "游泳", address: "游泳" },
        { value: "温泉", address: "温泉" },
        { value: "公共浴池", address: "公共浴池" },
        { value: "其他", address: "其他" }
      ],
      approach: "",
      reservationId: 0,
      year: 0,
      form: {
        virus: "",
        year: "",
        approach: ""
      },
      dialogFormVisible: false, //  新增 病毒携带史
      dialogTableVisible: false, //  form 编辑
      innerVisible: false, //  内层
      formLabelWidth: "130px",
      activeNames: [], //  手风琴参数
      info: {
        name: "",
        sex: "",
        age: 0,
        tel: "",
        img: ""
      },
      formData: [
        { text: "现病史:" },
        { text: "既往辅助检查:" },
        { text: "刻下:" },
        { text: "舌苔:" },
        { text: "脉象:" }
      ],
      all_sides: {
        allergicHistory: [],
        familyHistory: [],
        lifePartialAddicted: [],
        menstrual: [],
        pathogenyAndPathology: [],
        sideInformationA: [],
      },
      index: ""
    };
  },
  components: {
    inquiryone: InquiryOne
  },
  methods: {
    medicine(val){
      this.situation = val;
    },
    addbingdu: function() {
      if (this.virus == "") {
        this.$alert("请选择病毒携带史");
        return false;
      }
      if (this.approach == "") {
        this.$alert("请选择感染途径");
        return false;
      }
      let virusCarryingHistory = {
        //病毒携带史
        virus: this.virus, //病毒种类
        year: this.year, //病毒时间
        approach: this.approach //感染途径
      };
      this.gridData.push(virusCarryingHistory);
    },
    //小图标编辑
    edit: function() {
      this.virus = "";
      this.year = "";
      this.approach = "";
    },
    //编辑
    handleEdit(index, row) {
      this.index = index;
      this.dialogFormVisible = true;
      let virus = row.virus;
      let year = row.year;
      let approach = row.approach;
      this.virus = virus;
      this.year = year;
      this.approach = approach;
    },
    //删除
    handleDelete: function(index, row, rows) {
      rows.splice(index, 1);
    },
    handleSave() {
      let a = {
        virus: this.virus,
        year: this.year,
        approach: this.approach
      };
      this.gridData.splice(this.index, 1, a);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
    },
    inquiryLi() {
      //  切换就诊人
      this.$router.push({
        path: "/home/inquiryList"
      });
    },
    // 封装公共方法
    make_all_sides_data(all_sides, grid_data) {
      let all_data = JSON.parse(JSON.stringify(all_sides));  // 深拷贝
      let virus = ""; // 病毒携带
      for (let obj in all_data) {
        if (all_data[obj].length==0) {
          all_data[obj] = "";
        } else {
          for (let i = 0; i < obj.length; i++) {
            if (typeof obj[i] != "string") {
              all_data[obj][i] = "";
            }
          }
          all_data[obj] = all_data[obj].join("%");
        }
      }
      // 处理病毒携带字段
      for (let k = 0; k < grid_data.length; k++) {
        let b =
                grid_data[k].virus +
                ":" +
                grid_data[k].year +
                ":" +
                grid_data[k].approach;
        virus += b + ";";
      }
      virus = virus.substr(0, virus.length - 1);
      all_data.virus = virus
      return all_data;
    },

    finishDoctor() {
      this.$confirm("请确认所有信息都已保存", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let all_data = this.$options.methods.make_all_sides_data(this.all_sides, this.gridData);
          this.$axios({
            url: "/api/inquiry/" + this.reservationId,
            method: "PUT",
            data: {
              allergicHistory: all_data.allergicHistory,
              familyHistory: all_data.familyHistory,
              lifePartialAddicted: all_data.lifePartialAddicted,
              virusCarryingHistory: all_data.virus,
              menstrual: all_data.menstrual,
              pathogenyAndPathology: all_data.pathogenyAndPathology,
              sideInformationA: all_data.sideInformationA,
              emergencyCode:this.situation
            }
          })
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功"
                });
                this.$router.push({
                  //  没有数据页面
                  path: "/home/inquiryList"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "保存失败"
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消结束就诊"
          });
        });
    },
    saveUserHistory() {
      this.$confirm("请确认保存侧边病史", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let all_data = this.$options.methods.make_all_sides_data(this.all_sides, this.gridData);
          this.$axios({
            url: "/api/inquiry/userhistory/" + this.reservationId,
            method: "PUT",
            data: {
              allergicHistory: all_data.allergicHistory,
              familyHistory: all_data.familyHistory,
              lifePartialAddicted: all_data.lifePartialAddicted,
              virusCarryingHistory: all_data.virus,
              menstrual: all_data.menstrual,
              pathogenyAndPathology: all_data.pathogenyAndPathology,
              sideInformationA: all_data.sideInformationA,
            }
          })
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "保存失败"
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "前台取消保存"
          });
        });
    },

    // 修改一行
    changeOneRow(val, index, side_msg) {
      this.all_sides[side_msg][index] = val;
    },
    // 新增空行
    addOneRow(side_msg) {
      this.all_sides[side_msg].push("");
    },
    // 删除一行
    deleteOneRow(side_msg) {
      this.all_sides[side_msg].pop();
    },
    getData(rid) {
      this.$axios({
        url: "/api/inquiry/" + rid,
        method: "GET"
      })
        .then(res => {
          let that = this;
          let resData = res.data.data;
          let virus = {}; //  病毒携带式
          that.info.name = resData.patientBaseEntity.name;
          that.info.age = resData.patientBaseEntity.age;
          that.info.sex = resData.patientBaseEntity.gender;
          that.info.tel = resData.patientBaseEntity.mobileNumber;
          that.info.img = resData.patientBaseEntity.image;
          that.all_sides.familyHistory = resData.patientBaseEntity.familyHistory;
          that.all_sides.menstrual = resData.patientBaseEntity.menstrual;
          that.all_sides.allergicHistory = resData.patientBaseEntity.allergicHistory;
          that.all_sides.lifePartialAddicted = resData.patientBaseEntity.lifePartialAddicted;
          that.all_sides.pathogenyAndPathology = resData.patientBaseEntity.pathogenyAndPathology;
          that.all_sides.sideInformationA = resData.patientBaseEntity.sideInformationA;
          for (
            let i = 0;
            i < resData.patientBaseEntity.virusCarryingHistory.length;
            i++
          ) {
            let objArr = [];
            objArr = resData.patientBaseEntity.virusCarryingHistory[i].split(
              ":"
            );
            virus = {
              virus: objArr[0],
              year: objArr[1],
              approach: objArr[2]
            };
            that.gridData.push(virus);
          }
          if (resData.recipe == null) {
            // 汤方
            that.timeDate.recipe = null;
          } else {
            that.timeDate.recipe = resData.recipe;
          }
          if (resData.medicalRecord == null) {
            // 病例
            that.timeDate.haveData = null;
          } else {
            that.timeDate.haveData = resData.medicalRecord;
          }
          if (resData.otherCheckRecord == null) {
            // 辅助检查
            that.timeDate.assist = null;
          } else {
            that.timeDate.assist = resData.otherCheckRecord;
          }
          if (resData.measuredValue == null) {
            // 辅助检查
            that.timeDate.measure = null;
          } else {
            that.timeDate.measure = resData.measuredValue; // 测量值
          }
          this.$refs.c1.getData(that.timeDate);
        })
        .catch(err => {
          console.log(err);
        });
    },
    historyCase(rid) {
      this.$axios({
        url: "/api/inquiry/history/" + rid,
        method: "GET"
      })
        .then(res => {
          this.collapseData = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    let that = this;
    let transmitParams = that.$route.query;
    that.arrlength = transmitParams.length;
    that.timeDate = {
      doctorName: transmitParams.dName,
      periodOfTime: transmitParams.dTime,
      reservationId: transmitParams.rowData,
      pid: transmitParams.pid,
      did: transmitParams.did,
      sta: transmitParams.sta
    };
    that.state = transmitParams.sta;
    that.reservationId = transmitParams.rowData; // 调用接口 id
    that.getData(transmitParams.rowData);
    that.historyCase(transmitParams.pid);
  }
};
</script>

<style type="text/css" scoped>
.el-collapse-item__content{
  overflow: auto;
}
.el-button--primary {
  color: #fff;
  background-color:  rgb(60, 110, 169);
  border-color: rgb(60, 110, 169);
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
  color: #fff;
  background-color: rgba(60, 110, 169, 0.65);
  border-color: rgba(60, 110, 169, 0.65);
}
.el-button--primary:focus, .el-button--primary:hover {
  background: rgba(60, 110, 169, 0.65);
  border-color: rgba(60, 110, 169, 0.65);
  color: #fff;
}
.traditional {
  line-height: 35px;
}
.traditional span {
  display: inline-block;
  width: 120px;
  color: darkgreen;
}
.accordionTitle {
  font-size: 18px;
  color: #20a0ff;
}
.subheading p {
  line-height: 35px;
}
.subheading p span {
  display: inline-block;
  width: 120px;
  color: darkorange;
}
.doctorImg {
  display: inline-block;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.circle {
  float: right;
  margin-right: 15px;
}

.butn {
  text-align: center;
  width: 50px;
}

.in-past h2 {
  float: left;
  padding-right: 20px;
}

.contain {
  padding: 10px 15px;
  background: #f6f6f6;
}

.finishDoctor {
  display: inline-block;
  margin-left: 30px;
}

.contain .color {
  color: #20a0ff;
  cursor: pointer;
}

.contain a {
  color: blue;
  text-decoration: none;
}

.in-location h2 {
  font-weight: normal;
  font-size: 16px;
  color: #dcdcdc;
  padding: 10px 0 0 10px;
}

.containRow {
  margin: 0 !important;
}

.first-nav {
  line-height: 36px;
  height: 36px;
}

.in-btn button {
  padding: 10px 30px;
}

.in-content .Info {
  text-align: center;
  margin-top: 10px;
}

.in-con {
  box-shadow: 0 0 10px #dcdcdc;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  background: white;
  padding-top: 12px;
  margin-bottom: 30px;
}

.in-file {
  margin-top: 5px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dcdcdc;
}

.in-file a {
  margin-left: 25px;
}

.in-file i {
  margin-right: 5px;
}

.in-table,
.in-tel {
  height: 45px;
  text-align: left;
  border-bottom: 1px solid #dcdcdc;
}

.in-content h2 {
  font-weight: inherit;
  padding-left: 13px;
  color: #dcdcdc;
  margin: 0;
  font-size: 16px;
  display: inline-block;
}

.in-content h2 span {
  margin-left: 8px;
  color: black;
}

.in-table div {
  line-height: 45px;
  width: 48%;
  display: inline-block;
}


.in-tel h2 {
  line-height: 45px;
}

.in-remark {
  padding: 15px 0;
  text-align: left;
}

.in-remark h2 {
  width: 15%;
  display: inline-block;
}

.in-remark p {
  margin: 0;
  width: 70%;
  display: inline-block;
  white-space: pre-wrap;
}

.in-content .in-conTwo {
  padding-top: 0;
  text-align: left;
}

.in-header {
  height: 70px;
  line-height: 70px;
}

.in-header h2,
.in-text h2,
.in-past h2,
.in-disease p {
  margin-left: 8px;
  color: black;
  font-size: 20px;
}

.in-header span {
  display: inline-block;
  margin-right: 28px;
  cursor: pointer;
}

.in-header span i {
  margin-right: 10px;
}

.in-text {
  height: 60px;
  line-height: 60px;
  border-top: 1px solid #dcdcdc;
}

.in-text h2 {
  font-size: 18px;
  color: #787c7d;
  font-family: inherit;
}

.in-text h2 span {
  color: #dadcdb;
}

.in-text span {
  float: right;
  margin-right: 28px;
  color: blue;
  cursor: pointer;
}

.in-conThree {
  text-align: left;
  overflow: hidden;
  min-height: 53px;
}

.in-past {
  margin-bottom: 55px;
}

.in-date {
  margin: 8px 0 10px 21px;
}

.in-disease {
  padding-bottom: 12px;
  border-top: 1px solid #dcdcdc;
  font-size: 18px;
  margin: 0 auto;
  width: 89%;
}

.in-disease p {
  margin: 8px 15px 0 21px;
  display: block;
  white-space: pre-wrap;
}

.in-disDate {
  margin-left: 8px !important;
  color: #b6b6b6 !important;
}

.in-disBtn {
  margin: 8px 15px 0 21px;
}

.in-disBtn span {
  margin-right: 12px;
}

.in-disBtn span i {
  margin-right: 5px;
}

.in-disNone h2 {
  color: #b6b6b6;
  margin: 8px 15px 0 21px;
  font-size: 20px;
  display: block;
  padding: 0;
  height: 45px;
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// inquiry.vue?716935cb